export const BLOG_ARTICLE_PAGE = 'blog_article_page';
export const BLOG_CATEGORY_BLOCK = 'blog_category_block';
export const BLOG_CATEGORY_LANDING_PAGE = 'blog_category_landing_page';
export const CATEGORY_PAGE_URL = '/blog/category/health';
